module.exports = __webpack_public_path__ + "img/scene1-6.d3e3862c.png";